const queryOrganMge = r => require.ensure([], () => r(require('@/page/organMge/queryOrganMge/queryOrganMge')), 'queryOrganMge');
const organMge = r => require.ensure([], () => r(require('@/page/organMge/organMge')), 'organMge');

const Construction = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/Construction/Construction')), 'Construction');
const BuildUnit = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/BuildUnit/BuildUnit')), 'BuildUnit');
const OwnerTeam = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/OwnerTeam/OwnerTeam')), 'OwnerTeam');
const RealtyMgeCom = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/RealtyMgeCom/RealtyMgeCom')), 'RealtyMgeCom');
const ResidentsCommittee = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/ResidentsCommittee/ResidentsCommittee')), 'ResidentsCommittee');
const StreetOffice = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/StreetOffice/StreetOffice')), 'StreetOffice');
const AssessmentOrg = r => require.ensure([], () => r(require('@/page/organMge/editOrganMge/AssessmentOrg/AssessmentOrg')), 'AssessmentOrg');

// const organMgeInfo = r => require.ensure([], () => r(require('@/page/organMge/organMgeInfo/organMgeInfo')), 'organMgeInfo');

// /////////
const InstitutionUserManageList = r => require.ensure([], () => r(require('@/page/organMge/InstitutionUserManageList/InstitutionUserManageList')), 'InstitutionUserManageList');
const InstitutionUserManageEdit = r => require.ensure([], () => r(require('@/page/organMge/InstitutionUserManageEdit/InstitutionUserManageEdit')), 'InstitutionUserManageEdit');
const InstitutionUserManageAdd = r => require.ensure([], () => r(require('@/page/organMge/InstitutionUserManageAdd/InstitutionUserManageAdd')), 'InstitutionUserManageAdd');
const InstitutionUserManageDeatil = r => require.ensure([], () => r(require('@/page/organMge/InstitutionUserManageDeatil/InstitutionUserManageDeatil')), 'InstitutionUserManageDeatil');
const certificateIssued = r => require.ensure([], () => r(require('@/page/organMge/certificateIssued/certificateIssued')), 'certificateIssued');
const StatisticalSearch = r => require.ensure([], () => r(require('@/page/StatisticalSearch/StatisticalSearch')), 'StatisticalSearch');
///////////
const organMgeRouter = {
  path: '',
  component: organMge,
  meta: {
    icon: 'organMge',
    right: [],
    isShowMenu: true,
    keepAlive:false
  },
  name: '机构查询',
  redirect: '/queryOrganMge',
  children: [{
      path: '/queryOrganMge',
      component: queryOrganMge,
      name: '机构查询',
      meta: {
        right: ['机构信息管理'],
        isShowMenu: true,
        keepAlive:true,
      },
    }, {
      path: '/InstitutionUserManageList',
      component: InstitutionUserManageList,
      name: '机构用户管理',
      meta: {
        right: ['机构用户管理'],
        isShowMenu: true,
        keepAlive:true,
      },
    },
    {
      path: '/InstitutionUserManageEdit',
      component: InstitutionUserManageEdit,
      name: '修改用户信息',
      meta: {
        right: ['修改用户信息'],
        isShowMenu: false,
        keepAlive: true,
      },
    }, {
      path: '/InstitutionUserManageDeatil',
      component: InstitutionUserManageDeatil,
      name: '用户信息详情',
      meta: {
        right: ['用户信息详情'],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/InstitutionUserManageAdd',
      component: InstitutionUserManageAdd,
      name: '添加用户',
      meta: {
        right: ['添加用户'],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/Construction',
      component: Construction,
      name: '施工单位',
      meta: {
        right: ['施工单位'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/BuildUnit',
      component: BuildUnit,
      name: '开发建设单位',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/OwnerTeam',
      component: OwnerTeam,
      name: '业主委员会',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/RealtyMgeCom',
      component: RealtyMgeCom,
      name: '物业服务企业',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/ResidentsCommittee',
      component: ResidentsCommittee,
      name: '居民委员会',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/StreetOffice',
      component: StreetOffice,
      name: '街道办事处',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/AssessmentOrg',
      component: AssessmentOrg,
      name: '审价单位',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    // {
    //   path: '/organMgeInfo',
    //   component: organMgeInfo,
    //   name: '机构详情',
    //   meta: {
    //     right: [],
    //     isShowMenu: false,
    //     keepAlive: false,
    //   },
    // },

    {
      path: '/certificateIssued',
      component: certificateIssued,
      name: '证件发放',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/StatisticalSearch',
      component: StatisticalSearch,
      name: '统计查询',
      meta: {
        right: ['统计查询'],
        isShowMenu: true,
        keepAlive:true
      }
    },

  ]
};

export default organMgeRouter;
